import { Button, Drawer, Form, Select, Space } from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const SavePushDeliveryOrder = ({
  closeOriginalTab,
  open,
  close,
  setLoading,
  getPOUnsaveList,
  getMerchantOrderSaveList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [merchantList, setMerchantList] = useState({
    data: [],
    ready: false,
  });
  const [employeeList, setEmployeeList] = useState({
    data: [],
    ready: false,
  });

  const handleSaveToMerchantOrder = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    // invoice_from
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/commissary/push-delivery-merchant", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Push Delivery order successfully.");
          setTimeout(() => {
            closeOriginalTab();
            close();
            setLoadings(false);
            setLoading(false);
            getPOUnsaveList();
            getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const getMerchantList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/merchant-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getEmployeeList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/employee-list", { params })
      .then((response) => {
        const data = response.data;
        setEmployeeList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantList();
    getEmployeeList();
  }, [getMerchantList, getEmployeeList]);

  return (
    <Drawer
      title="Save Prepared Push Delivery Order"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="basic"
        initialValues={{ remember: true }}
        onFinish={handleSaveToMerchantOrder}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="merchant"
            label="Merchant"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select placeholder="Select merchant" size="large" showSearch>
              {merchantList.data.length > 0 ? (
                merchantList.data.map((data, index) => (
                  <Select.Option value={data.user_id} key={index}>
                    {data.fullname}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="">No merchant found!</Select.Option>
              )}
            </Select>
          </Form.Item>

          <Form.Item
            name="employee"
            label="C/O Employee"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select placeholder="Select employee" size="large" showSearch>
              {employeeList.data.length > 0 ? (
                employeeList.data.map((data, index) => (
                  <Select.Option value={data.employee_user_id} key={index}>
                    {data.firstname} {data.lastname}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="">No merchant found!</Select.Option>
              )}
            </Select>
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default SavePushDeliveryOrder;
